import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Toaster } from '@/shared/components/ui/sonner'
import { useEffect } from 'react'
import { useRemoteConfigStore } from '@/features/shared/stores/config.store'

const App = () => {
    const initializeConfig = useRemoteConfigStore((state) => state.initializeConfig)

    useEffect(() => {
        initializeConfig()
    }, [initializeConfig])

    return (
        <>
            <RouterProvider router={router} />
            <Toaster />
        </>
    )
}

export default App

